import Vue from 'vue'
export const RES_STATUS = {
  // FINE: 0,
  // FINISHED: 1,
  // CANCELLED: 2,
  // ABORTED: 3,
  // RESCHEDULED: 4,
  // COMING_SOON: 5,
  // ON_GOING: 8,
  CREATED: 0,
  //FINISHED(1, "已结束"),
  CANCELED: 2,
  //ABORTED: 3,
  RESCHEDULED: 4,
  REDEEMED: 5,
}
export const RES_SCHEDULE_STATUS = {
  EARLY: 0,
  COMING: 1,
  ON_GOING: 2,
  PASSED: 3,
}

export const RES_VO_STATUS = {
  RESED: 0,
  CANCELED: 1,
  RESCHEDULED: 2,
  VISITED: 3,
  COMING: 4,
  ON_GOING: 5,
  PASSED: 6,
}

export const getResStatus = (scheduleFrom, scheduleTo, resStatus) => {
  if (resStatus === RES_STATUS.CANCELLED) return resStatus
  if (resStatus === RES_STATUS.FINISHED) return resStatus
  //if ()
  let now = Date.now()
  let gap = scheduleFrom.getTime() - now
  gap = gap / (1000 * 3600)
  if (gap < 0) {
    if (scheduleTo.getTime() > now) return RES_STATUS.ON_GOING
    else return RES_STATUS.FINISHED
  } else if (gap < 2) return RES_STATUS.COMING_SOON
  else return resStatus
}

export const getResVOStatus = (res) => {
  if (res.resStatus === RES_STATUS.CANCELED) {
    return RES_VO_STATUS.CANCELED
  } else if (res.resStatus === RES_STATUS.REDEEMED) {
    return RES_VO_STATUS.VISITED
  } else if (res.resScheduleStatus === RES_SCHEDULE_STATUS.EARLY) {
    if (res.resStatus === RES_STATUS.RESCHEDULED) {
      return RES_VO_STATUS.RESCHEDULED
    } else if (res.resStatus === RES_STATUS.CREATED) {
      return RES_VO_STATUS.RESED
    }
  } else if (res.resScheduleStatus === RES_SCHEDULE_STATUS.COMING) {
    return RES_VO_STATUS.COMING
  } else if (res.resScheduleStatus === RES_SCHEDULE_STATUS.PASSED) {
    return RES_VO_STATUS.PASSED
  } else if (res.resScheduleStatus === RES_SCHEDULE_STATUS.ON_GOING) {
    return RES_VO_STATUS.ON_GOING
  }
  return ''
}
